import { render, staticRenderFns } from "./K98LinkComponent.vue?vue&type=template&id=111080c2&scoped=true"
import script from "./K98LinkComponent.vue?vue&type=script&lang=js"
export * from "./K98LinkComponent.vue?vue&type=script&lang=js"
import style0 from "./K98LinkComponent.vue?vue&type=style&index=0&id=111080c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111080c2",
  null
  
)

export default component.exports